<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="after_sales"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import { AFTERSALE_STATUS } from '@/constants';
import _ from 'lodash';

@Component
export default class Aftersales extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'so_id_cont',
      label: '订单号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'serial_no_cont',
      label: '退货单号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'l_id_cont',
      label: '快递单号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'order_buyer_account_cont',
      label: '买家账号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'scope',
      label: '状态',
      form: {
        component: 'select',
        props: {
          options: _.map(AFTERSALE_STATUS, (label, value) => ({ label, value }))
        }
      }
    }
  ]

  table = {
    data: []
  };

  get columns() {
    return createColumns.call(this);
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/after_sales', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
